
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class IvtIpIsBlacklisted extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_IP_BLACKLISTED';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.ipBlacklisted) {
      this.$set(this.conditions, 'ipBlacklisted', {
        predicate: 'EQUALS',
        values: 'IS_NOT_IP_BLACKLISTED'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.ipBlacklisted, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.ipBlacklisted, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.ipBlacklisted.values;
  }

}
